import React from 'react';
import './HeroAnimations.css';

export default function Hero() {
  return (
    <div style={styles.container}>
        <div className="shine-overlay" style={styles.shineOverlay}>
            <img 
            src="/hero-banner-tech.jpg" 
            alt="Tech mural hero banner" 
            style={styles.image}
            className="pan-animation" // class that triggers the animation keyframes
            />
        </div>
    </div>
  );
}

const styles = {
    container: {
        width: "100%",
        maxHeight: "400px",
        overflow: "hidden",
        position: "relative",
    },
    shineOverlay: {
      position: "relative",
      dislay: "block",
      height: "100%",
      width: "100%",
    },
    image: {
        height: "auto",
        width: "110%", /* ensure enough image after panning left animation */
        maxHeight: "400px",
        objectFit: "cover",
        display: "block"
        // animation is handled by className
    },
};
